import styled from 'styled-components'

export const BusinessSubscriptionComponent = styled.div`
  max-width: 34.5rem;
`

export const NoWrap = styled.span`
  white-space: nowrap;
`
